<template>
  <div class="prefix-input">
    <span
      v-if="prefix"
      class="prefix" >{{ prefix }}</span>
    <b-input
      v-model="inputValue"
      :style="inputStyle"
      :type="number ? 'number' : 'text'"
      class="sb2-bordered sb2-hoverable sb2-focusable"
      autocomplete="off"
      :placeholder="placeholder"
      :disabled="disabled" />
  </div>
</template>

<script>
export default {
  name: 'PrefixInput',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    prefix: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    number: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputValue: this.value,
      prefixPadding: 0,
    };
  },
  computed: {
    inputStyle() {
      return {
        paddingLeft: `${this.prefixPadding}px !important`,
      };
    },
  },
  watch: {
    value(newVal) {
      this.inputValue = newVal;
    },
    prefix: {
      immediate: true,
      handler() {
        // When the prefix changes, update the prefixPadding to match the width of the .prefix span
        this.$nextTick(() => {
          setTimeout(() => {
            const prefixEl = this.$el.querySelector('.prefix');
            if (prefixEl) {
              const width = prefixEl.offsetWidth;
              const leftValue = prefixEl.offsetLeft;
              this.prefixPadding = width + (leftValue * 1.5);
            } else {
              this.prefixPadding = 0;
            }
          }, 0);
        });
      },
    },
    inputValue(newVal) {
      this.$emit('input', newVal);
    },
  },
};
</script>

<style lang="scss" scoped>
.prefix-input {
  position: relative;

  .prefix {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #888;
    font-size: 14px;
    white-space: nowrap;
  }
}
</style>
